<template>
  <div class="modal is-active products-modal">
    <div class="modal-background" @click="$emit('close')" />

    <div class="modal-card products-modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Tuotteet</p>
        <button class="delete" aria-label="close" @click="$emit('close')" />
      </header>

      <section class="modal-card-body">
        <div class="columns is-multiline">
          <div v-for="category in productsByCategory" :key="category.slug"
            class="column is-6-tablet is-3-desktop">
            <h3 class="mb-4 is-clickable has-text-weight-bold" @click="selectCategory(category)">
              {{ category.name }}
            </h3>

            <ul>
              <li v-for="product in category.products" :key="product.id" @click="goToProductDetail(product.slug)"
                class="is-clickable product-link">
                {{ product.name }}
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import asModalDialogMixin from "@/helpers/modalMixing"

export default {
  name: 'productsModal',
  mixins: [
    asModalDialogMixin
  ],
  data() {
    return {
      publicPath: process.env.BASE_URL,
      search: ''
    }
  },
  methods: {
    goToProductDetail(productSlug) {
      this.$router.push({
        name: "ProductDetail",
        params: {
          productSlug: productSlug
        },
      });
    },
    selectCategory(category) {
      this.$store.commit('setSelectedCategory', category.slug)
      this.$router.push(`/${category.slug}`)
      // close modal
      this.$emit('close')
      this.$nextTick(() => {
        const element = document.getElementById("products-list");
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      })
    }
  },
  computed: {
    productsByCategory() {
      const grouped = new Map()

      this.$store.getters.getProducts.forEach(product => {
        if (!product.categories || !product.categories.length) {
          return
        }

        product.categories.forEach(category => {
          if (!grouped.has(category.slug)) {
            grouped.set(category.slug, { ...category, products: [] })
          }

          grouped.get(category.slug).products.push(product)
        })
      })

      return Array.from(grouped.values())
    }
  }
}
</script>

<style lang="scss" scoped>
@media (max-width: 768px) {
  .products-modal {
    .column {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
}

.products-modal {
  align-items: flex-start;
  padding-top: 80px;

  .products-modal-card {
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    height: calc(100vh - 120px);
    border-radius: 6px;
  }

  .modal-card-body {
    overflow-y: auto;
    padding: 2rem;
  }
}


h3 {
  font-size: 13px;
  font-weight: bold;
  font-family: Ubuntu;
  color: black
}

ul {
  li {
    font-size: 12px;
    font-family: Ubuntu;
  }

  li:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}

h3:hover {
  cursor: pointer;
  text-decoration: underline;
}
</style>
